const HEX_BASE = 16;
const GUID_PREFIX_LENGTH = 8;
const GUID_SUFFIX = "-0000-0000-0000-000000000000";
const PADDING_CHAR = "0";

export const convertIntegerToGUID = integer => {
  const base16Representation = integer.toString(HEX_BASE);
  const paddedLeading = base16Representation.padStart(GUID_PREFIX_LENGTH, PADDING_CHAR);

  return `${paddedLeading}${GUID_SUFFIX}`;
};

export const convertGUIDToInteger = guid => {
  if (!guid.endsWith(GUID_SUFFIX)) {
    return 0;
  }

  return parseInt(guid, HEX_BASE);
};
